import * as React from 'react';

export default function useMatchMedia(mediaQueryString, fallbackValue) {
  const media = React.useRef(null);
  const [state, setState] = React.useState(fallbackValue);

  React.useEffect(() => {
    function handleChange(event) {
      setState(event.matches);
    }

    function addListener() {
      if (media.current) {
        if (typeof media.current.addEventListener === 'function') {
          media.current.addEventListener('change', handleChange);
        } else if (typeof media.current.addEventListener === 'function') {
          // Support legact API implementations
          // @link https://developer.mozilla.org/en-US/docs/Web/API/MediaQueryList#instance_methods
          media.current.addListener('change', handleChange);
        }
      }
    }

    function removeListener() {
      if (media.current) {
        if (typeof media.current.removeEventListener === 'function') {
          media.current.removeEventListener('change', handleChange);
        } else if (typeof media.current.removeEventListener === 'function') {
          // Support legact API implementations
          // @link https://developer.mozilla.org/en-US/docs/Web/API/MediaQueryList#instance_methods
          media.current.removeListener('change', handleChange);
        }
      }
    }

    if (media.current && media.current.media !== mediaQueryString) {
      removeListener();
      media.current = null;
    }

    if (!media.current && 'matchMedia' in window) {
      media.current = window.matchMedia(mediaQueryString);
      setState(media.current.matches);
      addListener();
    }

    return removeListener;
  }, [mediaQueryString]);

  return state;
}
